import React, { FC, ReactNode } from 'react';

import CenteredLoader from '@eika-kortbetjening/state-handling-modal/lib/loader/Loader';
import { RowButton } from '@eika/button';
import { AccountSelectorLayoutProps } from '@eika/button/lib/RowButton/AccountSelectorLayout';
import { Icon, IconTypes } from '@eika/icon';
import { SubModal } from '@eika/modal';

interface Props extends AccountSelectorLayoutProps {
    error?: string;
    isLoading?: boolean;
    disabled?: boolean;
    locked?: boolean;
    subModalTitle?: string;
    subModalId: string;
    showModal: boolean;
    triggerModal: (boolean) => void;
    children: ReactNode;
    onModalClose: () => void;
}

const RowButtonModal: FC<Props> = ({
    label,
    placeholder,
    accountAlias,
    accountNumber,
    error,
    isLoading,
    disabled,
    locked = false,
    subModalTitle,
    subModalId,
    showModal,
    triggerModal,
    children,
    onModalClose,
}) => (
    <>
        <RowButton onClick={() => triggerModal(true)} disabled={disabled ?? locked}>
            <RowButton.AccountSelectorLayout
                label={label}
                placeholder={placeholder}
                accountAlias={accountAlias}
                accountNumber={accountNumber}
                error={error}
                icon={locked ? <Icon type={IconTypes.PIN_KODE_24} ariaLabel="Låst" /> : IconTypes.LITEN_PIL_HOEYRE}
            />
        </RowButton>
        <SubModal
            appNamespace="no-eika-kredittbank"
            id={subModalId}
            onClose={onModalClose}
            title={subModalTitle}
            open={showModal}
            setOpen={onModalClose}
        >
            {isLoading ? <CenteredLoader /> : <>{children}</>}
        </SubModal>
    </>
);

export default RowButtonModal;
